import { senior } from '@/api/seniors.js'
import { common } from '@/api/common'
import router from "@/router"
import store from '@/store'
import state from '../default/state'


const pattern = /[0-9]/
let res = null

export const seniors = {
    namespaced: true,
    state: {
        seniors: null,
        copiedSeniors: null, // temporary senior from orignal seniors

        //시니어 필터, 검색, 선택된 시니어
        listType: null,
        state: null,
        searchWord: null,
        selected: [],

        //시니어 정보보기
        seniorDetail: null,
        deputyInfo: null,
        guardianInfos: null,
        mailingInfos: null,

        // 시니어 메모
        slipSeniorInfo: null,
        seniorMemo: null,

        // 대시보드
        dashboard: null,
        afterCount: null,
        gradeCount: null,
        memoList: null,
        seniorJudgementList: null,

        // 캘린더 idx
        calendarIdx: null,

        seniorSimple: null
    },
    mutations: {
        SENIOR(state, payload) {
            state.seniors = payload.seniorInfo
        },
        RESET_SELECT(state) {
            //리스트
            state.listType = null
            state.state = null
            state.searchWord = null
            state.selected = []
            state.copiedSeniors = null

            // TODO: 다른페이지(수급자 -> 시니어 등) 이동 시 기존에 조회했던 상세정보를 모두 지운다.
            //시니어
            state.seniorDetail = null
            state.deputyInfo = null
            state.guardianInfos = null
            state.mailingInfos = null
            state.seniorMemo = null
        },
        SET_LIST_TYPE(state, payload) {
            state.listType = payload
            if (state.listType === '12') state.state = null
        },
        SET_SENIOR_STATE(state, payload) {
            state.state = payload
        },
        SET_SEARCH_WORD(state, payload) {
            state.searchWord = payload
        },
        ALL_CLEAN_SELECTED_SENIOR(state) {
            state.selected = []
        },
        ALL_SENIOR_SELECTED(state, payload) {
            if (!state.copiedSeniors) {
                return
            }
            if (state.selected.length) {
                state.selected = []
            } else {
                state.copiedSeniors.forEach(item => {
                    state.selected.push({ userIdx: item.userIdx, homeSeniorIdx: item.homeSeniorIdx })
                })
            }
        },
        SENIOR_SELECTED(state, payload) {
            let index = state.selected.findIndex(item => item.userIdx === payload.userIdx)
            if (index === -1) {
                state.selected.push({ userIdx: payload.userIdx, homeSeniorIdx: payload.homeSeniorIdx })
            } else {
                state.selected.splice(index, 1)
            }
        },
        CAL_SENIOR_SELECTED(state, payload) {
            state.calendarIdx = payload
        },
        REGIST_SENIOR(state, payload) {
            if (!state.seniors) state.seniors = []

            payload.seniorInfo['seniorRegistYmd'] = new Date().toISOString().substr(0, 10).replace(/-/g, '')
            payload.seniorInfo['gradeApplicationStateCode'] = '11'
            payload.seniorInfo['gradeApplicationStateCodeName'] = '등급미신청'
            payload.seniorInfo['userRegTypeCodeName'] =
                (payload.userRegTypeCode == '11') || (!payload.userRegTypeCode) ? '대기자' : '고객'

            state.seniors.unshift(payload.seniorInfo)
        },
        UPDATE_SENIOR(state, payload) {
            //시니어 상세정보
            state.seniorDetail = payload.seniorInfo
            state.deputyInfo = payload.seniorInfo.deputyInfo
            state.mailingInfos = payload.seniorInfo.mailingInfos
            state.guardianInfos = payload.seniorInfo.guardianInfos

            //시니어 리스트정보
            let index = state.seniors.findIndex(item => item.homeSeniorIdx === payload.seniorInfo.homeSeniorIdx)
                // payload.seniorInfo['seniorRegistYmd'] = state.seniors[index].seniorRegistYmd
                // payload.seniorInfo['userImagePath'] = state.seniors[index].userImagePath
                // payload.seniorInfo['gradeApplicationStateCode'] = state.seniors[index].gradeApplicationStateCode
                // payload.seniorInfo['gradeApplicationStateCodeName'] = state.seniors[index].gradeApplicationStateCodeName
            state.seniors.splice(index, 1, payload.seniorInfo)
        },
        CHANGE_GRADE_STATUS(state, payload) {
            let name = null
            switch (payload.grade) {
                case '11':
                    name = '등급미신청';
                    break
                case '12':
                    name = '등급신청완료';
                    break
                case '14':
                    name = '수급미계약';
                    break
                case '16':
                    name = '등급자격미달';
                    break
                case '17':
                    name = '등급판정완료';
                    break
            }
            let arr = state.seniors.filter(item => payload.idxs.includes(item.homeSeniorIdx))
            arr.forEach(item => {
                item.gradeApplicationStateCode = payload.grade
                item.gradeApplicationStateCodeName = name
                if (item.userRegTypeCode === '12' && payload.grade !== '11') {
                    item.userRegTypeCode = '11'
                    item.userRegTypeCodeName = '시니어'
                }
            })
        },
        SENIOR_DETAIL_INFO(state, payload) {
            state.seniorDetail = payload.userInfo
            state.deputyInfo = payload.deputyInfo
            state.guardianInfos = payload.guardianInfos
            state.mailingInfos = payload.mailingInfos
        },
        REGIST_SENIOR_IMAGE(state, payload) {
            console.log("state user image pay", payload)
            state.seniorDetail.userImagePath = payload.userInfo.userImagePath
            let obj = state.seniors.filter(item => item.userIdx === payload.userInfo.userIdx)
            obj[0].userImagePath = payload.userInfo.userImagePath

            if (state.slipSeniorInfo.userIdx === payload.userInfo.userIdx)
                state.slipSeniorInfo.userImagePath = payload.userInfo.userImagePath
        },
        DELETE_SENIOR_IMAGE(state, payload) {
            state.seniorDetail.userImagePath = null
            let obj = state.seniors.filter(item => item.userIdx === payload)
            obj[0].userImagePath = null
        },
        SENIOR_MEMO(state, payload) {
            state.seniorMemo = payload.userMemoList
            state.slipSeniorInfo = payload.seniorInfo
        },
        REGIST_SENIOR_MEMO(state, payload) {
            if (state.slipSeniorInfo.homeSeniorIdx === payload.memo.homeSeniorIdx) {
                if (!state.seniorMemo) state.seniorMemo = []
                state.seniorMemo.unshift(payload.memo)
            }
        },
        UPDATE_SENIOR_MEMO(state, payload) {
            let index = state.seniorMemo.findIndex(item => item.userConsultIdx === payload.midx)
            state.seniorMemo.splice(index, 1, payload.memo)
        },
        DELETE_SENIOR_MEMO(state, payload) {
            let index = state.seniorMemo.findIndex(item => item.userConsultIdx === payload)
            state.seniorMemo.splice(index, 1)
            if (!state.seniorMemo.length) state.seniorMemo = null
        },
        DELETE_SENIOR_MEMO_FILE(state, payload) {
            let files = state.seniorMemo[payload.mIndex].userConsultFileList
            files.splice(payload.index, 1)
            if (!files.length) files = null
        },
        CHARGE_STAFF(state, payload) {
            // router.push({ name: 'Senior'}).catch(()=>{})
            console.log(payload)
            let index = state.seniors.findIndex(item => item.homeSeniorIdx === payload[0])
            console.log(index)
            state.seniors.splice(index, 1)
            let index2 = state.selected.findIndex(item => item.homeSeniorIdx === payload[0])
            state.selected.splice(index2, 1)

            if (!state.seniors.length) state.seniors = null
        },
        REGIST_CUSTOMER(state, payload) {
            if (!state.seniors) state.seniors = []

            payload.seniorInfo['seniorRegistYmd'] = new Date().toISOString().substr(0, 10).replace(/-/g, '')
            payload.seniorInfo['gradeApplicationStateCode'] = '11'
            payload.seniorInfo['gradeApplicationStateCodeName'] = '등급미신청'
            state.seniors.unshift(payload.seniorInfo)
        },
        DASHBOARD(state, payload) {
            state.dashboard = payload
            state.afterCount = payload.afterCount
            state.gradeCount = payload.gradeCount
            state.memoList = payload.memoList
            state.seniorJudgementList = payload.seniorJudgementList
        },
        DELETE_SENIOR_COMPLETELY(state, payload) {
            let findIdx = state.seniors.findIndex(element => element.homeSeniorIdx === payload.idx)
            state.seniors.splice(findIdx, 1)
        },
        SENIOR_SIMPLE(state, payload) {
            state.seniorSimple = payload.seniorInfo
        },
        REGIST_SCHEDULE_MANAGEMENT(state, payload) {
            if(state.seniorSimple) {
                let index = state.seniorSimple.findIndex(item => item.homeSeniorIdx === payload)

                if(index !== -1) {
                    if(state.seniorSimple[index].editScheduleYn!=='Y') {
                        state.seniorSimple[index].editScheduleYn = 'Y'
                    }
                }
            }
        }
    },
    actions: {
        // @Description 시니어 조회(고객)
        async SENIOR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.senior(payload)
                console.log('SENIOR info', res)
                if (res.data.status === 200) {
                    commit('SENIOR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SENIOR error', error)

            }
        },
        // @Description 시니어 중복체크(현재기관)
        async SENIOR_OVERLAP({ commit }, payload) {
            try {
                res = await senior.get.overlapCheck(payload)
                console.log('SENIOR_OVERLAP info', res)
                return res.data
            } catch (error) {
                console.error('SENIOR_OVERLAP error', error)
            }
        },
        // @Description 시니어 등록(고객)
        async REGIST_SENIOR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.registSenior(payload)
                console.log('REGIST_SENIOR info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_SENIOR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SENIOR error', error)
            }
        },
        // @Description 시니어 수정(고객)
        async UPDATE_SENIOR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.updateSenior(payload)
                console.log('UPDATE_SENIOR info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_SENIOR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_SENIOR error', error)
            }
        },
        // @Description 시니어 등급상태변경
        async CHANGE_GRADE_STATUS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.status(payload)
                console.log('CHANGE_GRADE_STATUS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('CHANGE_GRADE_STATUS', {
                        idxs: payload.idxs,
                        grade: payload.gradeApplicationStateCode
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_GRADE_STATUS error', error)
            }
        },
        // @Description 시니어 상세정보 조회
        async SENIOR_DETAIL_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.seniorDetail(payload)
                console.log('SENIOR_DETAIL_INFO info', res)
                if (res.data.status === 200) {
                    commit('SENIOR_DETAIL_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SENIOR_DETAIL_INFO error', error)
            }
        },
        // @Description 시니어 프로필이미지 등록
        async REGIST_SENIOR_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.profileFile(payload)
                console.log('REGIST_SENIOR_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_SENIOR_IMAGE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SENIOR_IMAGE error', error)
            }
        },
        // @Description 시니어 프로필이미지 삭제
        async DELETE_SENIOR_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.delete.fileUpload(payload)
                console.log('DELETE_SENIOR_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SENIOR_IMAGE', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SENIOR_IMAGE error', error)
            }
        },
        // @Description 시니어 메모 조회
        async SENIOR_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.memo(payload)
                console.log('SENIOR_MEMO info', res)
                if (res.data.status === 200) {
                    commit('SENIOR_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SENIOR_MEMO error', error)
            }
        },
        // @Description 시니어 메모 등록 
        async REGIST_SENIOR_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.memo(payload)
                console.log('REGIST_SENIOR_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_SENIOR_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SENIOR_MEMO error', error)
            }
        },
        // @Description 시니어 메모 수정
        async UPDATE_SENIOR_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.updateMemo(payload)
                console.log('UPDATE_SENIOR_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_SENIOR_MEMO', {
                        midx: payload.midx,
                        memo: res.data.data.memo
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_SENIOR_MEMO error', error)
            }
        },
        // @Description 시니어 메모 삭제
        async DELETE_SENIOR_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.delete.memo(payload)
                console.log('DELETE_SENIOR_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SENIOR_MEMO', payload.midx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SENIOR_MEMO error', error)
            }
        },
        // @Description 시니어 첨부파일 삭제
        async DELETE_SENIOR_MEMO_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_SENIOR_MEMO_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SENIOR_MEMO_FILE', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SENIOR_MEMO_FILE error', error)
            }
        },
        // @Description 수급계약 담당자 선택
        async CHARGE_STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.chargeStaff(payload)
                console.log('CHARGE_STAFF info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    if (!payload.code) {
                        commit('CHARGE_STAFF', payload.homeSeniorIdx)
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHARGE_STAFF error', error)
            }
        },
        // @Description 고객등록
        async REGIST_CUSTOMER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.seniorCustomer(payload)
                console.log('REGIST_CUSTOMER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_CUSTOMER', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CUSTOMER error', error)
            }
        },
        // @Description 대시보드
        async DASHBOARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.dash(payload)
                console.log('DASHBOARD info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DASHBOARD', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD error', error)
            }
        },
        // @Description 고객대시보드 메모현황 조회
        async DASHBOARD_MEMOS_BOARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.dashSeniorMemo(payload)
                console.log('DASHBOARD_MEMOS_BOARD info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD_MEMOS_BOARD error', error)
            }
        },
        // @Description 고객대시보드 메모현황 조회
        async DASHBOARD_REGIST_CUSTOM_BOARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.dashRegistYear(payload)
                console.log('DASHBOARD_REGIST_CUSTOM_BOARD info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD_REGIST_CUSTOM_BOARD error', error)
            }
        },
        // @Description 시니어 삭제
        async DELETE_SENIOR_COMPLETELY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.delete.aSenior(payload)
                console.log('DELETE_SENIOR_COMPLETELY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SENIOR_COMPLETELY', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }

                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SENIOR_COMPLETELY error', error)
            }
        },
        // @Description 시니어 등록일 변경
        async REPLACE_REGIST_DATE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.registYmd(payload)
                console.log('REPLACE_REGIST_DATE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }

                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REPLACE_REGIST_DATE error', error)
            }
        },
        // @Description 고객메모(초기사정조사)현황
        async REGIST_CUSTOM_MEMO_BOARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.memoInflowList(payload)
                console.log('REGIST_CUSTOM_MEMO_BOARD info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CUSTOM_MEMO_BOARD error', error)
            }
        },
        // @Description 고객 등급인정(판정)진행현황
        async CUSTOM_LEVEL_PROGRESS_BOARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.judgeState(payload)
                console.log('CUSTOM_LEVEL_PROGRESS_BOARD info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CUSTOM_LEVEL_PROGRESS_BOARD error', error)
            }
        },
        // @Description 시니어리스트(캘린더용)
        async SENIOR_SIMPLE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.get.seniorSimple(payload)
                console.log('SENIOR_SIMPLE info', res)
                if (res.data.status === 200) {
                    commit('SENIOR_SIMPLE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SENIOR_SIMPLE error', error)
            }
        },
    },
    getters: {
        SENIOR_SIMPLE: state => {
            let arr = null
            state.selected = []
            if (!state.seniorSimple) return

            if (state.state) {
                arr = state.seniorSimple.filter(item =>
                    item.gradeApplicationStateCode === state.state
                )
                if (state.listType === '11') {
                    arr = arr.filter(item => item.userRegTypeCode === '11')
                } else if (state.listType === '12') {
                    arr = arr.filter(item => item.userRegTypeCode === '12')
                } else if (state.listType === '13') {
                    arr = arr.filter(item => item.createUserIdx === String(store.state.luidx))
                }
            } else {
                if (state.listType === '11') {
                    arr = state.seniorSimple.filter(item => item.userRegTypeCode === '11')
                } else if (state.listType === '12') {
                    arr = state.seniorSimple.filter(item => item.userRegTypeCode === '12')
                } else if (state.listType === '13') {
                    arr = state.seniorSimple.filter(item => {
                        return item.createUserIdx === store.state.luidx
                    })
                } else {
                    arr = state.seniorSimple
                }
            }

            if (state.searchWord) {
                if (pattern.test(state.searchWord)) {
                    arr = arr.filter(item => {
                        if (item.phoneNo) return item.phoneNo.includes(state.searchWord.clearValue())
                    })
                } else {
                    arr = arr.filter(item => item.seniorName.includes(state.searchWord))
                }
            }
            return state.copiedSeniors = arr
        },
        SENIOR: state => {
            let arr = null
            state.selected = []
            if (!state.seniors) return

            if (state.state) {
                arr = state.seniors.filter(item =>
                    item.gradeApplicationStateCode === state.state
                )
                if (state.listType === '11') {
                    arr = arr.filter(item => item.userRegTypeCode === '11')
                } else if (state.listType === '12') {
                    arr = arr.filter(item => item.userRegTypeCode === '12')
                } else if (state.listType === '13') {
                    arr = arr.filter(item => item.createUserIdx === String(store.state.luidx))
                }
            } else {
                if (state.listType === '11') {
                    arr = state.seniors.filter(item => item.userRegTypeCode === '11')
                } else if (state.listType === '12') {
                    arr = state.seniors.filter(item => item.userRegTypeCode === '12')
                } else if (state.listType === '13') {
                    arr = state.seniors.filter(item => {
                        return item.createUserIdx === store.state.luidx
                    })
                } else {
                    arr = state.seniors
                }
            }

            if (state.searchWord) {
                if (pattern.test(state.searchWord)) {
                    arr = arr.filter(item => {
                        if (item.phoneNo) return item.phoneNo.includes(state.searchWord.clearValue())
                    })
                } else {
                    arr = arr.filter(item => item.seniorName.includes(state.searchWord))
                }
            }
            return state.copiedSeniors = arr
        },
        SELECTED_IDX: state => {
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.userIdx)
                })
            }
            return arr
        },
        SELECTED_HIDX: state => {
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.homeSeniorIdx)
                })
            }
            return arr
        },
        SELECT_SENIOR: state => {
            if (state.seniors && state.selected && state.selected.length === 1) {
                let arr = state.seniors.filter(item => item.userIdx === state.selected[0].userIdx)
                return arr[0]
            } else {
                return null
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/seniors.js